<template>
  <header
    class="c-header c-header-mobile w-100 pb-0"
    :class="{ 'c-header-mobile--visible' : switcher}">
    <div class="container">
      <nav class="c-nav w-100">
        <div class="c-nav__left w-100 d-flex justify-content-center align-items-center my-5 py-5">
          <figure v-if="general.data"
            class="c-brand c-brand--normal d-flex justify-content-center align-items-center">
            <router-link class="c-brand__link" to="/">
              <img
                class="c-brand__image"
                :src="general.data.information.brand"
                alt="Panda WP - Logo"
              />
            </router-link>
          </figure>
        </div>
        <div class="c-nav__right mt-5">
          <div class="align-items-center d-flex flex-column">
              <a href="" class="c-header__link active mb-4">
                Proyecto
              </a>
              <a href="" class="c-header__link mb-4">
                Ubicación
              </a>
              <a href="" class="c-header__link mb-4">
                Galería
              </a>
              <a href="" class="c-header__link mb-4">
                Tipología
              </a>
              <a href="" class="c-header__link">
                Web Principal
              </a>
            </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['switcher'],
  computed: {
    ...mapState(['general']),
  },
  methods: {
    isAtiveMenuItem(item) {
      return item.slug.toLowerCase() === this.$route.name.toLowerCase();
    },
  },
};
</script>
